import state from "./moduleFuelConsumptionState.js";
import mutations from "./moduleFuelConsumptionMutations.js";
import actions from "./moduleFuelConsumptionActions.js";
import getters from "./moduleFuelConsumptionGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
